export default function NotFound() {
  return (
    <div className="flex min-h-dvh flex-col items-center justify-center px-6 text-center">
      <p className="text-4xl mb-4">🔍</p>
      <h1 className="text-lg font-semibold">Guide not found</h1>
      <p className="mt-2 text-sm text-muted-foreground">
        This link may have expired or is no longer valid.
        Please contact the property for a new link.
      </p>
    </div>
  )
}
